<template>
    <v-dialog
        :value="isOpen"
        max-width="900px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Uwagi jakościowe i reklamacje wewnętrzne
                </h1>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                            :headers="headers"
                            :items="qualitativeNotes"
                            :mobile-breakpoint="0"
                            :items-per-page="5"
                            :page.sync="currentPaginationPage"
                            :footer-props="{
                                itemsPerPageText: 'Zamówień na stronie',
                                showFirstLastPage: false
                            }"
                            name="ordersData"
                        >
                            <template #item.createdAt="{item}">
                                {{ formatDate(item.createdAt) }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'OrderQualitativeNotesDialog',
    mixins: [ dateFormatter ],
    props: {
        isOpen: {
            type: Boolean
        },
        qualitativeNotes: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            currentPaginationPage: null,
            headers: [
                {
                    text: 'Numer',
                    sortable: false,
                    value: 'number',

                },
                {
                    text: 'Zgłaszający',
                    sortable: false,
                    value: 'reportedBy',
                    align: 'center'

                },
                {
                    text: 'Proces',
                    sortable: false,
                    value: 'process',
                    align: 'center'

                },
                {
                    text: 'Kod',
                    sortable: false,
                    value: 'code',
                    align: 'center'

                },
                {
                    text: 'Data utworzenia',
                    sortable: false,
                    value: 'createdAt',
                    align: 'center'

                }
            ],
        }
    },
    methods: {
        resetPagination() {
            this.currentPaginationPage = 1
        },
        onClose() {
            this.$emit('on-close')
            this.resetPagination()
        }
    }
}
</script>